import { isBrandFile } from '@hub/common';
import type { BrandFile } from '@hub/common';

/** The brand file at `url` (its token download URL). */
export const fetchBrandFile = async (
  url: string,
  signal?: AbortSignal
): Promise<BrandFile> => {
  const response = await fetch(url, signal ? { signal } : undefined);
  if (!response.ok)
    throw new Error(
      `Brand file request failed with ${response.status.toString()}`
    );
  const file: unknown = await response.json();
  if (!isBrandFile(file)) throw new Error('Not a brand file');
  return file;
};
